import React, {FC, useEffect, useState} from 'react';
import styles from './header.module.scss'
import logo from "../../../images/headerLogo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { handleScroll as scrollToSection } from "../../../utils/scroll-helpers";
import { useAppSelector } from "../../../hooks/useAppSelector";
import Navigation from "./navigation/navigation";
import Button from '../../ui-kit/button/button';
import UserButton from '../user-button/user-button';
import SelectLanguage from '../select-language/select-language';
import { useTranslation } from 'react-i18next';


const Header: FC = () => {
    const [isScrolling, setIsScrolling] = useState<boolean>(false);
    const { user } = useAppSelector(state => state.user);
    const {pathname} = useLocation();
    const isHomePage = pathname === "/"
    const isLoginPage = pathname === '/login';

    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {

            const heightStartScreen = window.innerHeight;

            setIsScrolling(window.scrollY > heightStartScreen);
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [])

    const handleClickLogo = () => {
        if (isHomePage){
            return;
        }
        navigate(user? '/search': '/');
    }

    return (
        <div className={`${isHomePage ? styles.headerHome : styles.headerOther} ${isScrolling && isHomePage ? styles.scrolled : ''}`} id='app-header'>
            <div className={styles.container}>
                <div className={styles.branding}>
                    <img className={styles.logo + (!isHomePage ?` ${styles.link}` :'')} src={logo} alt={t('header.logoAlt')} onClick={handleClickLogo}/>
                    {!isHomePage && !isLoginPage && <Navigation handleScroll={scrollToSection} />}
                </div>
                {isHomePage && <Navigation handleScroll={scrollToSection} />}
                <div className={styles.right}>
                    <div className={styles.infoBtns}>
                        {pathname !== '/login' && <UserButton/>}
                        <SelectLanguage/>
                    </div>
                    {!isHomePage && !user && (
                        <Link to="/" style={{textDecorationLine:"none"}}>
                            <Button type='outline' className={styles.returnBtn}>{t('header.returnButton')}</Button>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header;
